'use strict'

import React from 'react'
import { Route } from 'react-router-dom'
import { AuthenticatedRoute, LogoutRoute, RedirectRoute, RedirectPortalRoute } from '../../components/auth'
import Loading from '../../components/loading'
import Loadable from 'react-loadable'
import { navPolicyMap } from '../../services/access-policy'

import {
    AdminIcon,
    AudienceIcon,
    ContentIcon,
    MessagingIcon,
    ReportsIcon,
    AiqIcon,
    DriveIcon,
    AtomIcon,
} from '../../components/svg-icon'
import jwt_decode from "jwt-decode";

const NotFound = Loadable({
    loader: () => import('../../pages/status/not-found-page'),
    loading: Loading
})

const apps = [
    {
        id: 'audience',
        path: 'audience',
        label: 'Audience',
        type: 'redirect',
        policy: {
            action: '*',
            resourceName: '*'
        },
        children: [
            {
                id: 'ab',
                path: 'ab',
                label: 'Audience Builder',
                policy: {
                    action: '*',
                    resourceName: '*'
                },
            },
            {
                id: 'sl',
                path: 'sl',
                label: 'Seed Lists',
                policy: {
                    action: '*',
                    resourceName: '*'
                },
            }
        ],
        dropdown: true,
        icon: AudienceIcon,
        hidden: true
    },
    {
        id: 'content',
        path: 'content',
        label: 'Content',
        type: 'redirect',
        icon: ContentIcon,
        dropdown: true,
        children: [
            {
                id: 'templates',
                path: 'templates',
                label: 'Templates',
                component: Loadable({
                    loader: () => import('../../pages/template-library-page'),
                    loading: Loading
                }),
                policy: {
                    action: navPolicyMap.uiViewTemplate
                },
                children: [
                    {
                        id: 'create',
                        path: 'create',
                        label: 'Create Template',
                        component: Loadable({
                            loader: () => import('../../pages/template-create-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiManageTemplate
                        },
                    },
                    {
                        id: ':id',
                        path: ':id',
                        label: 'Edit Template',
                        component: Loadable({
                            loader: () => import('../../pages/template-create-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiViewTemplate
                        },
                    }
                ]
            },
            {
                id: 'contentblocks',
                path: 'content-blocks',
                label: 'Content Blocks',
                component: Loadable({
                    loader: () => import('../../pages/content-block-page'),
                    loading: Loading
                }),
                policy: {
                    action: '*'
                },
                hidden: true
            },
            {
                id: 'offers',
                path: 'offers',
                label: 'Offers',
                component: Loadable({
                    loader: () => import('../../pages/offer-library-page'),
                    loading: Loading
                }),
                policy: {
                    action: navPolicyMap.uiViewOffer
                },
                children: [
                    {
                        id: 'create',
                        path: 'create',
                        label: 'Create Offer',
                        component: Loadable({
                            loader: () => import('../../pages/offer-create-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiManageOffer
                        },
                    },
                    {
                        id: ':id',
                        path: ':id',
                        label: 'Edit Offer',
                        component: Loadable({
                            loader: () => import('../../pages/offer-create-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiViewOffer
                        },
                    }
                ]
            },
            {
                id: 'images',
                path: 'images',
                label: 'Images',
                component: Loadable({
                    loader: () => import('../../pages/image-library-page'),
                    loading: Loading
                }),
                policy: {
                    action: navPolicyMap.uiViewImage
                },
                children: [
                    {
                        id: 'upload',
                        path: 'upload',
                        label: 'Upload Images',
                        component: Loadable({
                            loader: () => import('../../pages/image-upload-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiManageImage
                        },
                    },
                    {
                        id: ':id',
                        path: ':id',
                        label: 'Edit Image',
                        component: Loadable({
                            loader: () => import('../../pages/image-edit-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiManageImage
                        },
                    }
                ]
            }
        ]
    },
    {
        id: 'messaging',
        path: 'messaging',
        label: 'Messaging',
        type: 'redirect',
        icon: MessagingIcon,
        dropdown: true,
        children: [
            {
                id: 'mg',
                path: 'mg',
                label: 'Message Gallery',
                component: Loadable({
                    loader: () => import('../../pages/messaging-page'),
                    loading: Loading
                }),
                policy: {
                    action: navPolicyMap.uiViewMessage
                },
                children: [
                    {
                        id: 'newMessage',
                        path: 'newMessage',
                        label: 'New Message',
                        component: Loadable({
                            loader: () => import('../../pages/message-create-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiViewMessage
                        },
                    },
                    {
                        id: 'audiences',
                        path: 'audiences',
                        label: 'Audiences',
                        component: Loadable({
                            loader: () => import('../../pages/audience-grid-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiManageMessage
                        },
                    },
                    {
                        id: 'templateGrid',
                        path: 'templateGrid',
                        label: 'Template Grid',
                        component: Loadable({
                            loader: () => import('../../pages/template-list-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiManageMessage
                        },
                    },
                    {
                        id: 'templateEdit',
                        path: 'templateEdit',
                        label: 'Template Edit',
                        component: Loadable({
                            loader: () => import('../../pages/template-edit-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiManageMessage
                        },
                    },
                    {
                        id: 'testSend',
                        path: 'testSend',
                        label: 'Test Send',
                        component: Loadable({
                            loader: () => import('../../pages/test-send-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiManageMessage
                        },
                    },
                    {
                        id: 'schedule',
                        path: 'schedule',
                        label: 'Schedule',
                        component: Loadable({
                            loader: () => import('../../pages/schedule-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiManageMessage
                        },
                    },
                    {
                        id: 'messageReview',
                        path: 'messageReview',
                        label: 'Message Review',
                        component: Loadable({
                            loader: () => import('../../pages/message-review-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiManageMessage
                        }
                    },
                    {
                        id: 'messageDetail',
                        path: 'messageDetail',
                        label: 'Message Detail',
                        component: Loadable({
                            loader: () => import('../../pages/message-detail-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiViewMessage
                        },
                    }
                ]
            },
            {
                id: 'ma',
                path: 'ma',
                label: 'Marketing Automation',
                policy: {
                    action: '*',
                    resourceName: '*'
                },
                hidden: true
            }
        ]
    },
    {
        id: 'reporting',
        path: 'reporting',
        label: 'Reporting',
        icon: ReportsIcon,
        dropdown: true,
        type: 'redirect',
        children: [
            {
                id: 'ocp',
                path: 'ocp',
                label: 'Atom',
                component: Loadable({
                    loader: () => import('../../pages/reports-page'),
                    loading: Loading
                }),
                policy: {
                    action: navPolicyMap.uiViewOCPeReport
                }
            },
            {
                id: 'on-demand',
                path: 'on-demand',
                label: 'On Demand',
                component: Loadable({
                    loader: () => import('../../pages/reports-page'),
                    loading: Loading
                }),
                policy: {
                    action: navPolicyMap.uiViewOnDemandReport
                }
            },
            {
                id: 'digital',
                path: 'digital',
                label: 'Digital',
                component: Loadable({
                    loader: () => import('../../pages/reports-page'),
                    loading: Loading
                }),
                policy: {
                    action: navPolicyMap.uiViewDigitalReport
                },
                disable: true,
                hidden: true
            }
        ],
    },
    {
        id: 'admin',
        path: 'admin',
        label: 'Admin',
        icon: AdminIcon,
        dropdown: true,
        type: 'redirect',
        children: [
            {
                id: 'om',
                path: 'om',
                label: 'Organizations',
                component: Loadable({
                    loader: () => import('../../pages/account-management-page'),
                    loading: Loading
                }),
                policy: {
                    action: navPolicyMap.uiViewAccount
                },
                children: [
                    
                    {
                        id: 'create',
                        path: 'create',
                        label: 'Create New Organization',

                        component: Loadable({
                            loader: () => import('../../pages/account-create-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiViewAccount
                        }
                    },
                    {
                        id: ':id',
                        path: ':id',
                        label: 'Organizations',
                        component: Loadable({
                            loader: () => import('../../pages/account-management-detail-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiViewAccount
                        }
                    }
                ]
            },
            {
                id: 'am',
                path: 'am',
                label: 'Accounts',
                component: Loadable({
                    loader: () => import('../../pages/silo-management-page'),
                    loading: Loading
                }),
                policy: {
                    action: navPolicyMap.uiViewSilo
                },
                children: [
                    {
                        id: ':id',
                        path: ':id',
                        label: 'Accounts',
                        component: Loadable({
                            loader: () => import('../../pages/silo-management-detail-page'),
                            loading: Loading
                        }),
                        policy: {
                            action: navPolicyMap.uiViewSilo
                        },
                    }
                ]
            },
            {
                id: 'um',
                path: 'um',
                label: 'Users',
                policy: {
                    action: navPolicyMap.userRead,
                    resourceName: 'user'
                },
            },
            {
                id: 'sys',
                path: 'sys',
                label: 'System',
                component: Loadable({
                    loader: () => import('../../pages/system-page'),
                    loading: Loading
                }),
                policy: {
                    action: navPolicyMap.uiViewSystem
                }
            }
        ]
    }
]

let token = '';
if(window.location.pathname=='/login/gsm2'){
    const hash = window.location.hash.substring(1); // Remove the #
    const params = new URLSearchParams(hash);
    token = params.get('token');
}else{
    token = localStorage.getItem('cognito:token:id_token');
}
if(token!='' &&  token!=null){
    const { is_helix_user, is_direct_user, is_drive_user } = jwt_decode(token);
        if(is_helix_user){
            apps.push({
                id: 'audienceIQ',
                path: 'atom/audienceIQ',
                label: 'Audience IQ',
                type: 'redirectPortal',
                icon: AiqIcon,
                dropdown: false,
                policy: {
                    action: '*',
                    resourceName: '*'
                }
            })
        }
        if(is_direct_user){
            apps.push({
                id: 'atomDirect',
                path: 'atom/atomDirect',
                label: 'Direct',
                type: 'redirectPortal',
                icon: AtomIcon,
                dropdown: false,
                policy: {
                    action: '*',
                    resourceName: '*'
                }
            })
        }
        if(is_drive_user){
            apps.push({
                id: 'drive',
                path: 'atom/drive',
                label: 'Drive',
                type: 'redirectPortal',
                icon: DriveIcon,
                dropdown: false,
                policy: {
                    action: '*',
                    resourceName: '*'
                }
            })
        }
    
}


const util = [
    {
        id: 'switchWorkspace',
        path: 'switchWorkspace',
        component: Loadable({
            loader: () => import('../../pages/switch-workspace-page'),
            loading: Loading
        }),
        policy: {
            action: '*',
            resourceName: '*'
        },
        label: ''
    },
    {
        id: 'dashboard',
        path: 'dashboard',
        component: Loadable({
            loader: () => import('../../pages/dashboard-page'),
            loading: Loading
        }),
        policy: {
            action: '*',
            resourceName: '*'
        },
        label: 'Dashboard'
    },
    {
        id: 'login/gsm',
        path: 'login/gsm',
        component: Loadable({
            loader: () => import('../../pages/login-gsm-page'),
            loading: Loading
        }),
        type: 'route'
    },
    {
        id: 'login/gsm2',
        path: 'login/gsm2',
        component: Loadable({
            loader: () => import('../../pages/login-gsm-2-page'),
            loading: Loading
        }),
        type: 'route'
    },
    {
        id: 'loggedOut',
        path: 'loggedOut',
        component: Loadable({
            loader: () => import('../../pages/logged-out-page'),
            loading: Loading
        }),
        type: 'route'
    },
    {
        id: 'logout',
        path: 'logout',
        type: 'logout'
    },
    {
        id: '403',
        path: '403',
        component: Loadable({
            loader: () => import('../../pages/status/forbidden-page'),
            loading: Loading
        }),
        type: 'route'
    },
    {
        id: '500',
        path: '500',
        component: Loadable({
            loader: () => import('../../pages/status/server-error-page'),
            loading: Loading
        }),
        type: 'route'
    },
    {
        id: '*',
        path: '*',
        component: NotFound,
        type: 'route'
    }
]

const buildChildMap = (basePath, items) => {
    const map = {}

    items.forEach((item) => {
        const { path } = item

        item.route = [basePath, path].join('/')
        item.childMap = item.children ? buildChildMap(item.route, item.children) : []

        map[item.id] = item
    })

    return map
}

const lookupMap = buildChildMap('', [].concat(apps, util))

const buildRoute = (parent, nestedPath) => {
    switch (parent.type) {
        case 'redirect':
            return (
                <RedirectRoute
                    exact
                    from={nestedPath}
                    key={nestedPath}
                    navItem={parent}
                />
            )
        case 'route':
            return (
                <Route
                    component={parent.component || NotFound}
                    key={nestedPath}
                    path={nestedPath}
                />
            )
        case 'logout':
            return (
                <LogoutRoute
                    key={nestedPath}
                    path={nestedPath}
                />
            )
        case 'redirectPortal':
            return (
                <RedirectPortalRoute
                    key={nestedPath}
                    path={nestedPath}
                />
            )
        default:
            return (
                <AuthenticatedRoute
                    component={parent.component || NotFound}
                    key={nestedPath}
                    path={nestedPath}
                    policy={parent.policy}
                />
            )
    }
}

const generateRoutes = (children, path = '') => {
    return children
        .reduce((routes, parent) => {
            const nestedPath = [path, parent.path].join('/')
            if (!parent.children) {
                routes = routes.concat(buildRoute(parent, nestedPath))
            }
            else {
                routes = routes.concat(generateRoutes(parent.children, nestedPath))
                if (parent.component || parent.type === 'redirect') {
                    routes = routes.concat(buildRoute(parent, nestedPath))
                }
            }
            return routes
        }, [])
}

const canAccessNavItem = (navItem, authorizer, workspace) => {
    if (navItem.hidden) {
        return false
    }
    if (navItem.policy) {
        return authorizer.allowNav(navItem.policy, workspace)
    }

    if (navItem.children && navItem.dropdown) {
        return navItem.children.some((child) => canAccessNavItem(child, authorizer, workspace))
    }

    return false
}

const filterNavItems = (navItems, authorizer, workspace) => {
    const filteredNavItems = []

    navItems.forEach((navItem) => {
        if (navItem.hidden) {
            return
        }

        const { children, ...otherProps } = navItem
        const filteredNavItem = {
            _isFiltered: true,
            ...otherProps
        }
        if (children && children.length) {
            filteredNavItem.children = filterNavItems(children, authorizer, workspace)
        }

        const allowAccess = filteredNavItem.policy ?
            authorizer.allowNav(filteredNavItem.policy, workspace) :
            (filteredNavItem.children && filteredNavItem.children.length)

        if (allowAccess) {
            filteredNavItems.push(filteredNavItem)
        }
    })

    return filteredNavItems
}

const resolveRoute = (navItem, authorizer, workspace) => {
    if (navItem.type === 'redirect') {
        if (navItem.children) {
            const filteredChildren = navItem._isFiltered ? navItem.children : filterNavItems(navItem.children, authorizer, workspace)
            if (filteredChildren.length) {
                return filteredChildren[0].route
            }
        }

        return lookupMap['403'].route
    }

    return navItem.route
}

const findNavItemByRoute = (route, navItems = lookupMap) => {
    const parts = route.split('/').filter(f => f)

    while (parts.length > 0) {
        const part0 = parts.shift()
        const item = navItems[part0]

        if (!item) {
            return null
        }

        if (item.route === route) {
            return item
        }

        if (!item.childMap) {
            return null
        }

        navItems = item.childMap
    }

    return null
}

export default {
    apps,
    canAccessNavItem,
    filterNavItems,
    findNavItemByRoute,
    generateRoutes,
    lookupMap,
    resolveRoute,
    util
}



// WEBPACK FOOTER //
// src/services/route-map/index.js